<template>
  <div class="container-fluid">
    <loader-overlay v-if="apiRslt.fetch.inProgress"/>
    <slot/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import LoaderOverlay from "@/core/components/LoaderOverlay.vue";

export default {
  name: "NoFooter",
  components:{
    LoaderOverlay
  },
  computed:{
    ...mapState('auth',['apiRslt']),
  }
}
</script>

<style scoped>

</style>
